import VueRouter from "vue-router";
import Vue from "vue";
// 引入组件
import Index from '../views/Index'

// 注册
Vue.use(VueRouter)

// 声明路由路径
const router = new VueRouter({
    routes: [
        { path: '/', component: Index }
    ]
})

export default router